import { render, staticRenderFns } from "./ManageForumCategory.vue?vue&type=template&id=1f81f9f8&"
import script from "./ManageForumCategory.vue?vue&type=script&lang=js&"
export * from "./ManageForumCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports